import React, { useState } from "react";
import InputTextField from "../../../Components/Interfaces/InputTextField";
import DropdownField from "../../../Components/Interfaces/DropdownField";
import FormActionButtons from "../../../Components/Interfaces/FormActionButtons";
import { use } from "react";
import { useNavigate } from "react-router-dom";
import { PostAPI } from "../../../ApiServices/ApiServices";

const Signup = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    specialisation: "",
    practiceType: "",
    practiceName: "",
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const specialisationOptions = [
    { value: "cardiology", label: "Cardiology" },
    { value: "dermatology", label: "Dermatology" },
    { value: "neurology", label: "Neurology" },
    { value: "orthopedic", label: "Orthopedic" },
    { value: "general physician", label: "General Physician" },
  ];

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
const validateForm = () => {
  const newErrors = {};

if (!formData.fullName.trim()) {
  newErrors.fullName = "Full Name is required";
} else if (!/^[A-Za-z\s]+$/.test(formData.fullName.trim())) {
  newErrors.fullName = "Full Name should contain only alphabets";
}

  if (!formData.specialisation) {
    newErrors.specialisation = "Please select a specialisation";
  }

  if (!formData.practiceType) {
    newErrors.practiceType = "Please select a practice type";
  }

  if (!formData.practiceName.trim()) {
    newErrors.practiceName = "Practice Name is required";
  }

  if (!formData.email.trim()) {
    newErrors.email = "Email is required";
  } else if (
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
  ) {
    newErrors.email = "Invalid email address";
  }

  if (!formData.password) {
    newErrors.password = "Password is required";
  } else if (formData.password.length < 6) {
    newErrors.password = "Password must be at least 6 characters";
  }

  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};
const handleSubmit = () => {
   if (!validateForm()) return;
  const payload = {
    full_name: formData.fullName,
    email: formData.email,
    password: formData.password,
    practice_name: formData.practiceName,
    practice_type: formData.practiceType,
    specialization: formData.specialisation,
  };

  PostAPI(
    {
      url: "auth/doctor/register",
      data: payload,
    },
    (res) => {
      if (res?.success) {
        console.log("Signup success:", res);
        navigate("/"); // or login page
      } else {
        console.error("Signup error:", res?.message);
      }
    }
  );
};

  return (
    <div className="login-form container">
      <div className="row justify-content-center">
        <h4 className="form-head forgot-ps">Sign Up</h4>

       <div className="col-10 m-2">
  <div
    className="p-4 bg-white signup-scroll"
    style={{
      borderRadius: "20px",
      // border: "1px solid #000405",
    }}
  >
            {/* Full Name */}
            <div className="mb-3">
              <InputTextField
                label="Full Name "
                placeholder="Enter Full Name here"
                value={formData.fullName}
                onChange={(e) => handleChange("fullName", e.target.value)}
                error={errors.fullName}
                required
              />
            </div>

            {/* Specialisation */}
            <div className="mb-3">
              <DropdownField
                label="Specialisation "
                placeholder="Select Specialisation"
                options={specialisationOptions}
                value={formData.specialisation}
                className="bg-bl2 border-0"
                required
                onChange={(e) =>
                  handleChange("specialisation", e.target.value)
                }
                error={errors.specialisation}
              />
            </div>

            {/* Practice Type */}
            <div className="mb-3">
            <label className="fw-semibold mb-2 d-block">
              Practice Type <span className="text-danger">*</span>
            </label>

              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="radio"
                  name="practiceType"
                  value="solo"
                  checked={formData.practiceType === "solo"}
                  onChange={(e) =>
                    handleChange("practiceType", e.target.value)
                  }
                />
                <label className="form-check-label">
                  Solo Clinic
                </label>
              </div>

              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="radio"
                  name="practiceType"
                  value="multi"
                  checked={formData.practiceType === "multi"}
                  onChange={(e) =>
                    handleChange("practiceType", e.target.value)
                  }
                />
                <label className="form-check-label">
                  Multi-Doctor Clinic
                </label>
              </div>

              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="practiceType"
                  value="hospital"
                  checked={formData.practiceType === "hospital"}
                  onChange={(e) =>
                    handleChange("practiceType", e.target.value)
                  }
                />
                <label className="form-check-label">
                  Hospital
                </label>
              </div>
              {errors.practiceType && (
  <div className="c-r fs-xs fw-r">
    {errors.practiceType}
  </div>
)}
            </div>

            {/* Practice Name */}
            <div className="mb-3">
              <InputTextField
                label="Practice Name "
                placeholder="Enter here"
                value={formData.practiceName}
                required
                onChange={(e) =>
                  handleChange("practiceName", e.target.value)
                }
                error={errors.practiceName}
              />
            </div>

            {/* Email */}
            <div className="mb-3">
              <InputTextField
                label="Email ID "
                placeholder="Enter email ID here"
                required
                type="email"
                value={formData.email}
                autocomplete="email"
                onChange={(e) => handleChange("email", e.target.value)}
                error={errors.email}
              />
            </div>

            {/* Password */}
            <div className="mb-4">
              <InputTextField
                label="Password "
                type="password"
                required
                placeholder="Enter Password here"
                value={formData.password}
                autocomplete="new-password"
                onChange={(e) =>
                  handleChange("password", e.target.value)
                }
                error={errors.password}
              />
            </div>

            {/* Signup Button */}
            <div className="d-grid">
              <FormActionButtons
                submitLabel="Signup"
                onSubmit={handleSubmit}
                onCancel={()=>navigate("/")}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;